import Vue from "vue"
import axios from 'axios'
import swal from 'sweetalert'

let token = localStorage.getItem('accessToken');
const appAxios = axios.create({
    headers:{
        authorization: `Bearer ${token}`,
        "content-type": "application/json",
        "Accept": "application/json"
    }
});
const onErrorResponse = async (error) => {

  if (error.response) {
      if (error.response.status === 401 &&  error.response.data.message === 'Unauthenticated.') {

          localStorage.clear();
          swal({
              title: "Unauthenticated",
              text: "You are not authorized to perform this action",
              icon: "error",
              // buttons: true,
              dangerMode: true,
            })
            .then((willDelete) => {
              if (willDelete) {
                  window.location = '/auth/signin'
              } else {
                  window.location = '/auth/signin'
              }
            });

      }else{
          return error.response;
      }
  }

  return error;
}

const onSuccessResponse = (response) => {
  return response;
}

appAxios.interceptors.response.use(
  onSuccessResponse,
  onErrorResponse
)

export default appAxios;
